import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import Styles from 'src/components/Styles';

function SendASnack() {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <Path
        d="M11.153 4.56A3.172 3.172 0 008.42 3h-.077a3.094 3.094 0 00-2.756 4.5h-.9C3.756 7.5 3 8.256 3 9.188v2.25c0 .734.471 1.36 1.125 1.592v5.72A2.252 2.252 0 006.375 21h11.25a2.252 2.252 0 002.25-2.25v-5.72A1.692 1.692 0 0021 11.438v-2.25c0-.932-.756-1.688-1.688-1.688h-.9A3.096 3.096 0 0015.657 3h-.077a3.172 3.172 0 00-2.732 1.56L12 6.007l-.847-1.442v-.003zm8.16 4.628v2.25h-6.188v-2.25h6.187zm-8.438 0v2.25H4.687v-2.25H10.876zm0 3.937v6.188h-4.5a.564.564 0 01-.563-.563v-5.625h5.063zm2.25 6.188v-6.188h5.063v5.625c0 .31-.254.563-.563.563h-4.5zM15.656 7.5H13.08l1.224-2.081a1.482 1.482 0 011.276-.731h.077a1.406 1.406 0 110 2.812zm-4.781 0H8.344a1.406 1.406 0 110-2.813h.077c.524 0 1.013.278 1.276.732L10.921 7.5h-.046z"
        fill={Styles.Colors.PayNew.black01}
      />
    </Svg>
  );
}

const SendASnackIcon = React.memo(SendASnack);

export default SendASnackIcon;
